"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextWithIcon = exports.StyledMargin = exports.StyledCustomise = exports.StyledInlineText = exports.StyledInlineHyperLink = exports.StyledLogoUploader = exports.StyledRow = exports.StyledQRImage = exports.StyledQRPreview = exports.StyledTabsSubtitle = exports.StyledTabHeader = exports.StyledContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContainer = styled_components_1.default.div `
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
exports.StyledTabHeader = (0, styled_components_1.default)(ui_common_components_1.Tabs) `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  justify-content: space-between;
  position: relative;
  width: 100%;
`;
exports.StyledTabsSubtitle = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.MediumSmall)};
`;
exports.StyledQRPreview = styled_components_1.default.div `
  display: flex;
  width: 100%;
  max-width: ${ui_common_components_1.utils.rem(264)};
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  justify-content: center;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  min-height: ${ui_common_components_1.utils.rem(176)};
  position: relative;
  align-items: center;

  ${({ waterMarkUrl }) => waterMarkUrl &&
    (0, styled_components_1.css) `
      position: relative;

      &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url('${waterMarkUrl}');
        background-size: cover;
        background-repeat: no-repeat;
        opacity: 0.5;
      }
    `};
`;
exports.StyledQRImage = styled_components_1.default.div `
  display: flex;
  width: ${({ theme }) => ui_common_components_1.utils.rem(theme.Components.QrCode.Size.Width)};
  opacity: ${({ isDefault }) => (isDefault ? 0.5 : 1)};

  svg {
    flex: 1;
    border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Border.Radius.Medium)};
  }
`;
exports.StyledRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  padding-left: 0;
`;
exports.StyledLogoUploader = styled_components_1.default.div `
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.Color.Neutrals.Light};
  text-align: center;
  border-radius: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  height: 150px;
  align-items: center;
  justify-content: center;
`;
exports.StyledInlineHyperLink = styled_components_1.default.a `
  display: inline-block;
  color: ${({ theme }) => theme.Color.System.Primary};
`;
exports.StyledInlineText = (0, styled_components_1.default)(ui_common_components_1.Text) `
  display: inline-block;
  color: ${({ theme }) => theme.Color.System.Primary};
  cursor: pointer;
`;
exports.StyledCustomise = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledMargin = styled_components_1.default.div ``;
exports.StyledTextWithIcon = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
//# sourceMappingURL=QRCode.style.js.map